export const RESPONSE_MAPPING_COPY = {
  addField: '+ Add mapping manually',
  agentFieldHeader: 'Field the agent sees',
  discoveredFieldsHint: 'Select a field to add it to what the agent receives.',
  discoveredFieldsLegend: 'Fields found in this response',
  draftPreviewTitle: 'This preview uses your current draft.',
  jsonHint:
    'Build nested objects or arrays whose final values each select one API response field. Transformations and fixed values are not supported.',
  jsonLabel: 'Response mapping (JSON)',
  jsonMode: 'Advanced JSON mapping',
  invalidSampleMessage: "That isn't valid JSON yet, so the preview is paused.",
  mappingHeading: 'Fields the agent receives',
  mappingHeadingHint: 'Select fields above or add a mapping manually.',
  mappedFieldLabel: 'Mapped',
  namePlaceholder: 'appointmentId',
  pathHeader: 'API response field or path',
  pathPlaceholder: 'appointment_id or data.appointment_id',
  passthroughNotice:
    "No mapping yet — the agent receives your API's entire response, unchanged. Map fields to send only what the agent needs, and keep anything sensitive out.",
  previewPassthroughBadge: 'everything',
  previewResultTitle: 'What the agent gets',
  previewSamplePrompt: 'Paste a sample response above to see what the agent would receive.',
  previewSourceTitle: "Your API's response",
  previewUpdatingStatus: 'Updating…',
  removeHeader: 'Remove',
  rowFallback: 'field',
  sampleFieldHint:
    'Run the saved tool in the Test runner or paste a real API response. Samples are never saved.',
  sampleFieldLabel: 'Sample response',
  savedTestRunnerNote: 'The Test runner executes the last saved configuration.',
  sectionSubtitle:
    "Use a real response to choose exactly what the agent receives. Everything you don't map is left out.",
  sectionTitle: 'Test & shape the response',
  simpleMode: 'Simple',
  testRunnerDescription:
    'Runs the last saved configuration against a real tenant and contact. Unsaved form changes apply to the mapping preview, not this test. Claim checks and credentials are evaluated for real.',
} as const;

/** Builds the accessible label for a response-mapping output-name input. */
export const responseFieldNameLabel = (rowLabel: string): string => `${rowLabel} name`;

/** Builds the accessible label for a response-mapping source-path input. */
export const responseFieldPathLabel = (rowLabel: string): string => `${rowLabel} response path`;

/** Builds the accessible label for a response-mapping row removal button. */
export const removeResponseFieldLabel = (rowLabel: string): string => `Remove ${rowLabel}`;

/** Builds the action label for an unmapped field discovered in a sample response. */
export const addDiscoveredResponseFieldLabel = (outputName: string): string => `Add as ${outputName}`;
